import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import Seo from '../Seo';
import './ContentPostDetail.css';

// Reusable detail view for News/Articles.
const ContentPostDetail = ({ service, basePath }) => {
    const { slug } = useParams();
    const [post, setPost] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        setLoading(true);
        setError(null);
        service.getBySlug(slug)
            .then(({ data }) => setPost(data))
            .catch(() => setError('Материал не найден.'))
            .finally(() => setLoading(false));
    }, [service, slug]);

    if (loading) return <div className="content-detail__placeholder">Загрузка...</div>;
    if (error || !post) return <div className="content-detail__placeholder">{error || 'Материал не найден.'}</div>;

    return (
        <article className="content-detail">
            <Seo title={post.title} description={post.summary || undefined} image={post.coverImageUrl || undefined} />
            <Link to={basePath} className="content-detail__back">← Ко всем материалам</Link>
            <h1 className="content-detail__title">{post.title}</h1>
            {post.publishedAt && (
                <div className="content-detail__date">{new Date(post.publishedAt).toLocaleDateString('ru-RU')}</div>
            )}
            {post.coverImageUrl && (
                <img src={post.coverImageUrl} alt={post.title} className="content-detail__cover" />
            )}
            <div className="content-detail__body" dangerouslySetInnerHTML={{ __html: post.contentHtml }} />
        </article>
    );
};

export default ContentPostDetail;
